/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { numericPixels } from "../../../../../global/emotion";
import { ReaderThumbnail } from "../../blocks/data/ReaderThumbnail/ReaderThumbnail.emotion";

const containerStyle: Interpolation = {
  display: "flex",
  height: numericPixels[80],
  placeContent: "center",
  placeItems: "flex-end",
  width: numericPixels[80],
};

interface TranscriptThumbnailProps {
  activated: boolean;
  imageSrc: any;
  playing: boolean;
  isHeaderCollapsed: boolean;
  title: string;
  onPlay: () => void | Promise<void>;
}

export const TranscriptThumbnail = ({
  activated,
  imageSrc,
  playing,
  isHeaderCollapsed,
  title,
  onPlay,
}: TranscriptThumbnailProps) => {
  return (
    <div css={containerStyle}>
      <ReaderThumbnail
        activated={activated}
        imageSrc={imageSrc}
        playing={playing}
        isHeaderCollapsed={isHeaderCollapsed}
        title={title}
        onClickCapture={onPlay}
      />
    </div>
  );
};
